var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ScaleBox',[_c('div',{staticClass:"mr-visual"},[_c('v-header-box'),_c('div',{staticClass:"mr-visual-left"}),_c('transition',{attrs:{"name":"el-fade-in-linear"}},[_c('div',{staticClass:"mr-visual-container"})]),_c('div',{staticClass:"mr-visual-right"}),_c('div',{staticClass:"mr-visual-footer"},[_c('v-footer')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }